import React from 'react'
import { HStack, Radio, Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import PayPayLogoImage from '@images/external_payment/paypay_logo.webp'

export const PayPayOption = ({ isSelected, onChange }) => (
  <HStack w="100%" p="16px" align="center" spacing={3} cursor="pointer" onClick={onChange}>
    <Radio isChecked={isSelected} colorScheme="red" size="lg" />
    <Image w="85px" h="23px" src={buildAssetUrlString(PayPayLogoImage)} alt="PayPay" objectFit="contain" />
  </HStack>
)
